import React from "react";
import EditorOverlay from "./EditorOverlay";
import { useLocalStoryModel } from "./storyModel";

/**
 * EditorPreview — lets the authoring surface be tried and reviewed before the real
 * story data layer (product/story, 3DPresenter-Codex) is wired in.
 *
 * It renders the overlay over whatever the host already shows, driven by the local
 * in-memory stand-in. Everything except persistence behaves like the final editor.
 */
export const EditorPreview: React.FC<{ onFocusStep?: (id: string, i: number) => void }> = ({ onFocusStep }) => {
    const model = useLocalStoryModel();
    return <EditorOverlay model={model} onFocusStep={onFocusStep} saveState="local" />;
};

export default EditorPreview;
